<template>
  <b-col sm="12" md="3">
    <b-card
      tag="article"
      class="mb-2 content-center no-border"
    >
      <img
        :src="require(`../../public/${image_name}`)"
        height="150px"
        class="d-inline-block align-top"
        alt="AAlborg University"
      />
      <b-card-text class="mt-2">
        <h5>{{ name }}</h5>
        <p>
          {{ description }} <br /> 
          <b-icon icon="briefcase" class="mr-2"></b-icon>{{ company }} <br />
          <b-icon icon="envelope" class="mr-2"></b-icon>{{ email }} <br />
          <b-icon icon="telephone" class="mr-2"> </b-icon>{{ phone }}
        </p>
      </b-card-text>
    </b-card>
  </b-col>
</template>

<script>
export default {
  props: ["name", "phone", "image_name", "email", "description", "company"],
};
</script>